import React from 'react';
import { FeatureFlag } from './FeatureFlag.js';

/**
 * Usage of FeatureFlagWrapper component.
 *
 * @example
 * <FeatureFlagWrapper flag="feature-1">
 *   <h3>Fő feature</h3>
 *   <strong>
 *     test - <i>freature 1 text</i>
 *   </strong>
 *   <hr />
 * </FeatureFlagWrapper>
 *
 * Usage of FeatureFlagWrapper component.
 *
 * @example
 * <FeatureFlagWrapper disabledFlag="feature-1">
 *   <h3>Míg nincs bekapcsolva a featrue-1</h3>
 * </FeatureFlagWrapper>
 */ const FeatureFlagWrapper = (props)=>{
    const { children } = props;
    if ("flag" in props && FeatureFlag.isEnabled(props.flag) || "disabledFlag" in props && !FeatureFlag.isEnabled(props.disabledFlag)) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
    }
    return null;
};

export { FeatureFlagWrapper };
//# sourceMappingURL=FeatureFlagWrapper.js.map
